var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowsOut = function SvgIconArrowsOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.5a1 1 0 0 1 1-1h3.75a1 1 0 0 1 0 2H6.914l3.543 3.543a1 1 0 0 1-1.414 1.414L5.5 6.914V8.25a1 1 0 0 1-2 0zM17.086 5.5H15.75a1 1 0 1 1 0-2h3.75a1 1 0 0 1 1 1v3.75a1 1 0 1 1-2 0V6.914l-3.543 3.543a1 1 0 0 1-1.414-1.414zM10.457 13.543a1 1 0 0 1 0 1.414L6.914 18.5H8.25a1 1 0 1 1 0 2H4.5a1 1 0 0 1-1-1v-3.75a1 1 0 1 1 2 0v1.336l3.543-3.543a1 1 0 0 1 1.414 0M13.543 13.543a1 1 0 0 1 1.414 0l3.543 3.543V15.75a1 1 0 1 1 2 0v3.75a1 1 0 0 1-1 1h-3.75a1 1 0 1 1 0-2h1.336l-3.543-3.543a1 1 0 0 1 0-1.414"
  }))));
};
export default SvgIconArrowsOut;